/**
 * @flow
 * @relayHash 0217142e5a707055f33ea4130e88bf49
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProfileChangeAvatarInput = {|
  clientMutationId?: ?string,
  revisionMessage?: ?string,
|};
export type ProfileChangeAvatarMutationVariables = {|
  input: ProfileChangeAvatarInput
|};
export type ProfileChangeAvatarMutationResponse = {|
  +meProfileChangeAvatar: ?{|
    +viewer: ?{|
      +id: string,
      +me: ?{|
        +id: string,
        +username: string,
        +isAuthenticated: ?boolean,
        +avatar: ?{|
          +url: string
        |},
      |},
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +location: ?string,
      +message: string,
    |}>,
  |}
|};
export type ProfileChangeAvatarMutation = {|
  variables: ProfileChangeAvatarMutationVariables,
  response: ProfileChangeAvatarMutationResponse,
|};
*/


/*
mutation ProfileChangeAvatarMutation(
  $input: ProfileChangeAvatarInput!
) {
  meProfileChangeAvatar(input: $input) {
    viewer {
      id
      me {
        id
        username
        isAuthenticated
        avatar(width: 40, height: 40) {
          url
        }
      }
    }
    errors {
      code
      location
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ProfileChangeAvatarInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "meProfileChangeAvatar",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProfileChangeAvatarPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "username",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAuthenticated",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "avatar",
                "storageKey": "avatar(height:40,width:40)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 40
                  },
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 40
                  }
                ],
                "concreteType": "File",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileChangeAvatarMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileChangeAvatarMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ProfileChangeAvatarMutation",
    "id": null,
    "text": "mutation ProfileChangeAvatarMutation(\n  $input: ProfileChangeAvatarInput!\n) {\n  meProfileChangeAvatar(input: $input) {\n    viewer {\n      id\n      me {\n        id\n        username\n        isAuthenticated\n        avatar(width: 40, height: 40) {\n          url\n        }\n      }\n    }\n    errors {\n      code\n      location\n      message\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6ad144d212d4d60307754cab8b491756';
module.exports = node;
